import { ServiceConnectionModel } from 'app/shared/models/server/service-connection-model';

export class AuthenticationModel extends ServiceConnectionModel {
    employeeNumber = 0;
    pinCode = '';

    constructor(fields?: Partial<AuthenticationModel>) {
        super();
        if (fields) {
            Object.assign(this, fields);
        }
    }
}
